export default "__VITE_ASSET__BS0WVYct__";